import { NAV_ITEMS } from "../Shell/nav-items";

// Descriptions relevant to how this page is used for
// data informed community engagement for public safefty
const aboutActionHubDescription = {
  home: "Welcome to the Simsi Platform. This is your home page.",
  resources:
    "This is your resource inventory. Here you can manage your resources.",
  actions: "This is your action plan. Here you can manage your actions.",
  strategies:
    "This is your strategy inventory. Here you can manage your strategies.",
  sharing: "This is your sharing page. Here you can share your resources.",
  goals: "This is your goal inventory. Here you can manage your goals.",
  learn: "This is your learning inventory. Here you can manage your learning.",
  teamwork: "This is your teamwork page. Here you can manage your teamwork.",
};

export const AboutActionHubSteps = (currentHubId: string) => {
  return NAV_ITEMS(currentHubId).map((item) => ({
    disableBeacon: true,
    target: `[data-tour-target="${item.tourTarget}"]`,
    content:
      aboutActionHubDescription[
        item.tourTarget as keyof typeof aboutActionHubDescription
      ],
  }));
};
